/** Sites — English, the source of the other languages */
const sites = {
  "sites.deleted": "Site deleted",
  "sites.deleteFailed": "Failed to delete site",
  "sites.syncTriggered": "Sync triggered",
  "sites.syncFailed": "Sync failed",
  "sites.managed": { one: "{count} site managed", other: "{count} sites managed" },
  "sites.addSite": "Add site",
  "sites.site": "Site",
  "sites.location": "Location",
  "sites.lastSync": "Last sync",
  "sites.none": "No sites yet — add your first UniFi site",
  "sites.notInLicence": "Not in your licence",
  "sites.configureDevice": "Configure device",
  "sites.syncNow": "Sync now",
  "sites.confirmDelete": "Delete site \"{name}\"?",
  "sites.add.title": "Add UniFi site",
  "sites.add.name": "Site name *",
  "sites.add.namePlaceholder": "Head Office",
  "sites.add.locationPlaceholder": "London, UK",
  "sites.add.descriptionPlaceholder": "Optional description",
  "sites.add.apiKey": "UniFi API Key *",
  "sites.add.apiKeyPlaceholder": "API key from UniFi Network Application",
  "sites.add.signInWith": "Sign in with",
  "sites.add.signInKey": "API key (UniFi OS console)",
  "sites.add.signInLogin": "User name and password (self-hosted Network Server)",
  "sites.add.username": "User name *",
  "sites.add.password": "Password *",
  "sites.add.loginHint": "A self-hosted Network Server has no API keys: use a local account on it without two-step verification. The password is stored encrypted and never shown.",
  "sites.add.controllerUrl": "Controller URL",
  "sites.add.hintConsole": "UniFi OS console (Dream Machine, Cloud Gateway, Cloud Key):",
  "sites.add.hintSelfHosted": "Self-hosted Network Server:",
  "sites.add.hintSiteManager": "For consoles reached through unifi.ui.com use “+ Site Manager”.",
  "sites.add.siteId": "Site ID",
  "sites.add.note": "Note:",
  "sites.add.noteText": "After adding, a VPN account will be provisioned automatically. The site will become active once it connects via VPN.",
  "sites.synced": "Synced",
  "sites.notFound": "Site not found",
  "sites.back": "Back to sites",
  "sites.firmwareAvailable": "⬆ Firmware available",
  "sites.lastSyncWhen": "Last sync {when}",
  "sites.never": "never",
  "sites.sync": "Sync",
  "sites.tab.overview": "Overview",
  "sites.tab.topology": "Topology",
  "sites.tab.devices": "Devices ({count})",
  "sites.tab.vlans": "VLANs ({count})",
  "sites.tab.wifi": "WiFi ({count})",
  "sites.tab.clients": "Clients ({count})",
  "sites.tab.traffic": "Traffic",
  "sites.tab.alerts": "Alerts",
  "sites.tab.alertsCount": "Alerts ({count})",
  "sites.connectedNow": "connected now",
  "sites.connectionsUp": "connections up",
  "sites.download": "Download",
  "sites.upload": "Upload",
  "sites.uploadRate": "{rate} upload",
  "sites.experienceScore": "Experience score",
  "sites.wifiGood": "✓ Good WiFi experience",
  "sites.wifiFair": "⚠ Fair WiFi experience",
  "sites.wifiPoor": "✕ Poor WiFi experience",
  "sites.averageAcross": { one: "Average across {count} wireless client", other: "Average across {count} wireless clients" },
  "sites.wanConnections": "WAN connections",
  "sites.loadBalanced": "Load balanced",
  "sites.noWan": "No WAN data yet",
  "sites.throughput": "Throughput",
  "sites.noHistory": "No history yet",
  "sites.noTopology": "No topology data — sync the site first",
  "sites.networkTopology": "Network topology",
  "sites.connectionsCount": { one: "{count} connection", other: "{count} connections" },
  "sites.legend.wired": "— Wired link",
  "sites.legend.wireless": "– – Wireless (mesh) link",
  "sites.legend.ap": "📶 Access Point",
  "sites.legend.switch": "🔀 Switch",
  "sites.legend.gateway": "🔒 Gateway",
  "sites.legend.clientCount": "🔵 = client count",
  "sites.legend.update": "⬆ = update available",
  "sites.model": "Model",
  "sites.type": "Type",
  "sites.experience": "Experience",
  "sites.firmwareUpdate": "⬆ Firmware update available",
  "sites.radios": "Radios",
  "sites.channel": "Ch {channel}",
  "sites.utilization": "Util: {percent}%",
  "sites.noDevices": "No devices",
  "sites.update": "⬆ Update",
  "sites.uptime": "UPTIME",
  "sites.clientsCaps": "CLIENTS",
  "sites.radioTable": "Radio table",
  "sites.channelUtilization": "Ch utilization",
  "sites.portTable": "Port table",
  "sites.port": "Port",
  "sites.portN": "Port {n}",
  "sites.speed": "Speed",
  "sites.down": "Down",
  "sites.upBadge": "UP",
  "sites.downBadge": "DOWN",
  "sites.uptimeDays": "{d}d {h}h",
  "sites.uptimeHours": "{h}h {m}m",
  "sites.vlanId": "VLAN ID",
  "sites.purpose": "Purpose",
  "sites.subnet": "Subnet",
  "sites.noVlans": "No VLANs",
  "sites.noWifi": "No WiFi networks",
  "sites.guest": "GUEST",
  "sites.clientsLower": "clients",
  "sites.busiest": "Busiest: {ap} ({count})",
  "sites.client": "Client",
  "sites.connection": "Connection",
  "sites.noClients": "No clients",
  "sites.conn.wired": "wired",
  "sites.conn.wireless": "wireless",
  "sites.dpi.0": "Other",
  "sites.dpi.1": "Instant messaging",
  "sites.dpi.2": "P2P",
  "sites.dpi.3": "File transfer",
  "sites.dpi.4": "Streaming",
  "sites.dpi.5": "Mail",
  "sites.dpi.6": "VoIP",
  "sites.dpi.7": "Gaming",
  "sites.dpi.8": "Social media",
  "sites.dpi.9": "Advertising",
  "sites.dpi.10": "Web",
  "sites.dpi.11": "Security",
  "sites.dpi.other": "Cat {n}",
  "sites.noDpi": "No DPI data — requires UniFi with DPI enabled",
  "sites.trafficByCategory": "Traffic by category",
  "sites.breakdown": "Breakdown",
  "sites.noActiveAlerts": "No active alerts",
  "sites.config.field.enableDisable": "Link enabled",
  "sites.config.help.enableDisable": "Bring the uplink up or down",
  "sites.config.field.priority": "Priority",
  "sites.config.help.priority": "Lower number wins when multiple links are up",
  "sites.config.field.failover": "Failover",
  "sites.config.help.failover": "Switch to a backup link when this one fails",
  "sites.config.field.loadBalance": "Load balancing",
  "sites.config.help.loadBalance": "Spread sessions across active links",
  "sites.config.field.weights": "Balance weight",
  "sites.config.help.weights": "Share of traffic for this link",
  "sites.config.field.healthCheck": "Health check",
  "sites.config.help.healthCheck": "Probe the link and mark it down on failure",
  "sites.config.field.smartQueue": "Smart Queue (QoS)",
  "sites.config.help.smartQueue": "Reduce bufferbloat under load",
  "sites.config.field.staticIp": "Static IP",
  "sites.config.help.staticIp": "Leave blank for DHCP",
  "sites.config.field.mtu": "MTU",
  "sites.config.help.mtu": "Usually 1500, or 1492 for PPPoE",
  "sites.config.field.simSwitch": "Active SIM slot",
  "sites.config.help.simSwitch": "Switching drops the connection briefly",
  "sites.config.field.apn": "APN",
  "sites.config.help.apn": "Carrier access point name",
  "sites.config.field.dataLimit": "Monthly data limit",
  "sites.config.help.dataLimit": "Alerts fire at 90% of this",
  "sites.config.field.roaming": "Allow roaming",
  "sites.config.help.roaming": "Costly outside the home network",
  "sites.config.field.bandLock": "Band lock",
  "sites.config.help.bandLock": "Comma-separated bands, blank = auto",
  "sites.config.field.pin": "SIM PIN",
  "sites.config.field.ssid": "SSID",
  "sites.config.field.security": "Security",
  "sites.config.field.band": "Band",
  "sites.config.field.guest": "Guest network",
  "sites.config.help.guest": "Isolates clients from the LAN",
  "sites.config.field.vlanTag": "VLAN tag",
  "sites.config.field.schedule": "Schedule enabled",
  "sites.config.field.txPower": "TX power",
  "sites.config.field.fastRoaming": "Fast roaming (802.11r)",
  "sites.config.field.mode": "Role",
  "sites.config.field.frequency": "Frequency",
  "sites.config.help.frequency": "60 GHz radios: 58320, 60480, 62640, 64800 or 66000",
  "sites.config.field.channelWidth": "Channel width",
  "sites.config.help.channelWidth": "Not used on 60 GHz",
  "sites.config.field.protocol": "Protocol",
  "sites.config.help.protocol": "2.4/5 GHz \"wireless\" driver only",
  "sites.config.field.linkKey": "Link key",
  "sites.config.help.linkKey": "At least 8 characters; must match on both ends. Never shown once saved",
  "sites.config.field.linkTxPower": "TX power",
  "sites.config.help.linkTxPower": "Stay within the limit of your regulatory domain",
  "sites.config.field.linkSsid": "Link name (SSID)",
  "sites.config.help.linkSsid": "Must match on both ends",
  "sites.config.field.vlan": "VLAN",
  "sites.config.field.dhcp": "DHCP server",
  "sites.config.field.firewall": "Firewall",
  "sites.config.field.portForward": "Port forwarding",
  "sites.config.field.staticRoutes": "Static routes",
  "sites.config.field.dns": "DNS servers",
  "sites.config.help.dns": "Comma-separated",
  "sites.config.field.speedfusion": "SpeedFusion",
  "sites.config.field.reconnect": "Reconnect tunnel",
  "sites.config.help.reconnect": "Drops and re-establishes the bond",
  "sites.config.field.createProfile": "New profile",
  "sites.config.field.vpnClient": "VPN client",
  "sites.config.field.reboot": "Reboot device",
  "sites.config.help.reboot": "Device is offline for 1-2 minutes",
  "sites.config.field.firmwareCheck": "Check for firmware",
  "sites.config.field.firmwareUpgrade": "Install firmware",
  "sites.config.help.firmwareUpgrade": "Applies the latest available build",
  "sites.config.field.backup": "Back up config",
  "sites.config.field.restore": "Restore config",
  "sites.config.field.ntp": "NTP server",
  "sites.config.field.timezone": "Timezone",
  "sites.config.field.hostname": "Hostname",
  "sites.config.field.adminPassword": "Admin password",
  "sites.config.section.wan": "WAN",
  "sites.config.blurb.wan": "Uplink behaviour, failover and load balancing",
  "sites.config.section.cellular": "Cellular",
  "sites.config.blurb.cellular": "SIM, APN, data limits and roaming",
  "sites.config.section.wifi": "WiFi",
  "sites.config.blurb.wifi": "SSIDs, security and radio settings",
  "sites.config.section.link": "Radio link",
  "sites.config.blurb.link": "Point-to-point / point-to-multipoint link settings. Change each station first, then the access point within 10 minutes; the frequency is set on the access point only.",
  "sites.config.section.network": "Network",
  "sites.config.blurb.network": "VLANs, DHCP, firewall and routing",
  "sites.config.section.tunnel": "Tunnels",
  "sites.config.blurb.tunnel": "SpeedFusion and VPN client profiles",
  "sites.config.section.system": "System",
  "sites.config.blurb.system": "Reboot, firmware, time and identity",
  "sites.config.option.ap-ptp": "Access point — point-to-point",
  "sites.config.option.ap-ptmp": "Access point — point-to-multipoint",
  "sites.config.option.station": "Station (far end / CPE)",
  "sites.config.option.open": "open",
  "sites.config.option.both": "both",
  "sites.config.option.auto": "auto",
  "sites.config.option.low": "low",
  "sites.config.option.medium": "medium",
  "sites.config.option.high": "high",
  "sites.config.option.any": "any",
  "sites.config.applied": { one: "Applied {count} change", other: "Applied {count} changes" },
  "sites.config.someFailed": "Some changes failed",
  "sites.config.unsupportedHere": "Unsupported on this device",
  "sites.config.title": "Configure {name}",
  "sites.config.subtitle": "Only options this device supports are shown",
  "sites.config.hide": "Hide",
  "sites.config.history": "History",
  "sites.config.apply": "Apply {count}",
  "sites.config.missing": "Missing configuration: {items} — reconnect this site to enable config.",
  "sites.config.readOnly": "{label} is read-only through this dashboard. Monitoring still works normally.",
  "sites.config.readFailed": "The current settings could not be read from the device",
  "sites.config.readFailedNote": "The fields below are empty because they are unknown, not because they are off.",
  "sites.config.available": "Available on this device",
  "sites.config.appliesTo": "Applies to",
  "sites.config.notSupportedBy": "Not supported by {label}",
  "sites.config.raw": "Raw device state",
  "sites.config.changed": "changed",
  "sites.config.notReported": "Current state not reported by the device",
  "sites.config.unknownState": "Current state unknown",
  "sites.config.discard": "Discard this change",
  "sites.config.historyTitle": "Config change history",
  "sites.config.noChanges": "No changes recorded yet",
  "sites.config.when": "When",
  "sites.config.section": "Section",
  "sites.config.field": "Field",
  "sites.config.value": "Value",
  "sites.search": "Search sites",
  "sites.searchPlaceholder": "Search by name…",
  "sites.brand": "Brand",
  "sites.allBrands": "All brands",
  "sites.noneMatch": "No sites match",
  "sites.matching": { one: "{count} site matches", other: "{count} sites match" },
  "sites.config.offline.copy": "This unit is offline — showing its settings as read {when}. Changes are saved and sent when it is back.",
  "sites.config.offline.none": "This unit has not been reached yet — changes are saved and sent at its first contact.",
  "sites.config.offline.save": "Save for later ({count})",
  "sites.config.offline.saved": { one: "{count} change saved for when the unit is back", other: "{count} changes saved for when the unit is back" },
  "sites.config.offline.pendingValue": "pending: {value} · {by} · {when}",
  "sites.pending.title": "Pending changes",
  "sites.pending.waitingUnit": "Sent when the unit is back",
  "sites.pending.conflict": "Changed on the unit to {unit} — yours: {mine}",
  "sites.pending.keepMine": "Keep mine",
  "sites.pending.keepUnit": "Keep the unit's",
  "sites.pending.waitingFor": "Waiting for {names} to take its own link change first",
  "sites.pending.release": "Push anyway",
  "sites.pending.failed": "Failed: {error}",
  "sites.pending.discard": "Discard",
  "sites.pending.decision": "Decision needed",
  "sites.pending.count": { one: "{count} pending", other: "{count} pending" },
  "sites.config.offline.noneSeen": "This unit does not answer now, and its settings have not been read yet — changes are saved and sent at its next contact.",
  "sites.cloud.status.OK": "Working",
  "sites.cloud.status.WAITING_VPN": "Waiting for its VPN",
  "sites.cloud.status.FAILED": "Failed",
  "sites.cloud.reach.PUBLIC": "At an address",
  "sites.cloud.reach.VIA_SITE_VPN": "Through a site's VPN",
  "sites.cloud.reach.OWN_VPN": "The controller's own VPN connection",
  "sites.cloud.reachHint.PUBLIC": "The controller answers at a public address with a valid certificate.",
  "sites.cloud.reachHint.VIA_SITE_VPN": "A device at one of your sites with a VPN connection forwards the controller's port — no cloud subscription, no open port.",
  "sites.cloud.reachHint.OWN_VPN": "The controller's computer connects to the platform's VPN itself (OpenVPN on Windows or Linux).",
  "sites.cloud.reachHint.needsVpn": "Needs the permission to manage VPN connections.",
  "sites.cloud.connectionName": "Name",
  "sites.cloud.connectionNamePlaceholder": "e.g. Head office controller",
  "sites.cloud.reachLabel": "How the dashboard reaches the controller",
  "sites.cloud.address": "Controller address",
  "sites.cloud.addressHint": "A valid certificate is needed: at a public address nothing else proves who answers.",
  "sites.cloud.noVpnSites": "None of your sites has a VPN connection yet. Add one first (a MikroTik, a UniFi gateway or any VPN client at that location).",
  "sites.cloud.viaSite": "Site",
  "sites.cloud.chooseSite": "Choose a site",
  "sites.cloud.port": "Controller port",
  "sites.cloud.forwardIntro": "On the device at {site}, forward port {port} of its VPN address {ip} to the controller's LAN address.",
  "sites.cloud.lanAddress": "The controller's LAN address",
  "sites.cloud.forwardMikrotik": "On a MikroTik, in its terminal:",
  "sites.cloud.lanPlaceholder": "<controller's LAN address>",
  "sites.cloud.credentials": "Omada's credentials",
  "sites.cloud.credentialsWhere": "In the Omada controller, open {menu}, add an application in Client mode and copy its Client ID and Client secret. The Omada ID is shown on the same page.",
  "sites.cloud.omadacId": "Omada ID",
  "sites.cloud.clientId": "Client ID",
  "sites.cloud.clientSecret": "Client secret",
  "sites.cloud.keptPlaceholder": "Set — leave empty to keep it",
  "sites.cloud.registerTitle": "Add Omada sites",
  "sites.cloud.registerSubtitle": "A TP-Link Omada controller's sites, reached through your VPN or at an address",
  "sites.cloud.savedWaiting": "Saved — waiting for the controller's VPN connection",
  "sites.cloud.connected": "Connected to the controller",
  "sites.cloud.connectFailed": "Could not connect",
  "sites.cloud.otherConnection": "Another connection",
  "sites.cloud.failed": "Last error: {reason}",
  "sites.cloud.editInSettings": "Edit the connection",
  "sites.cloud.useConnection": "Use a connection",
  "sites.cloud.newConnection": "A new connection",
  "sites.cloud.connect": "Connect",
  "sites.cloud.downloadFailed": "Download failed",
  "sites.cloud.waitingTitle": "Waiting for the controller's VPN connection",
  "sites.cloud.waitingText": "Download this VPN connection and start it on the controller's computer. Once its tunnel is up the credentials are checked and the controller's sites appear here — this page looks again every 10 seconds.",
  "sites.cloud.downloadOvpn": "Download .ovpn",
  "sites.cloud.ovpnWindows": "Windows: install OpenVPN, import the file and connect; set the OpenVPN service to start automatically so the tunnel comes back after a restart.",
  "sites.cloud.ovpnLinux": "Linux: copy the file to /etc/openvpn/client/velanox.conf and run systemctl enable --now openvpn-client@velanox.",
  "sites.cloud.added": { one: "{count} site added", other: "{count} sites added" },
  "sites.cloud.addFailed": "Could not add the sites",
  "sites.cloud.sitesFailed": "The controller's sites could not be read: {reason}",
  "sites.cloud.controllerSites": "The controller's sites",
  "sites.cloud.noControllerSites": "The controller has no sites.",
  "sites.cloud.deviceCount": { one: "{count} device", other: "{count} devices" },
  "sites.cloud.alreadyAdded": "Added",
  "sites.cloud.addSites": { one: "Add {count} site", other: "Add {count} sites" },
  "sites.cloud.through": "Through {name} · {reach}",
  "sites.cloud.synced": "synced {when}",
  "sites.cloud.configure": "Configure",
  "sites.cloud.devicesOnline": "Devices online",
  "sites.cloud.clients": "Clients",
  "sites.cloud.uplinksUp": "Uplinks up",
  "sites.cloud.openAlerts": "Open alerts",
  "sites.cloud.devices": "Devices",
  "sites.cloud.noDevices": "No devices on this site yet.",
  "sites.cloud.type": "Type",
  "sites.cloud.uptime": "Uptime",
  "sites.cloud.deviceType.ap": "Access point",
  "sites.cloud.deviceType.switch": "Switch",
  "sites.cloud.deviceType.gateway": "Gateway",
  "sites.cloud.deviceType.other": "Other",
  "sites.cloud.updateAvailable": "Update available",
  "sites.cloud.restart": "Restart",
  "sites.cloud.restartSent": "Restart sent",
  "sites.cloud.restartConfirm": "Restart {name}? Its clients lose their connection for about two minutes.",
  "sites.cloud.upgrade": "Update firmware",
  "sites.cloud.upgradeSent": "Firmware update started",
  "sites.cloud.upgradeConfirm": "Update the firmware of {name}? It restarts, and its clients lose their connection for about two minutes.",
  "sites.cloud.noClients": "No clients connected.",
  "sites.cloud.connection": "Connection",
  "sites.cloud.blocked": "Blocked",
  "sites.cloud.wireless": "Wireless",
  "sites.cloud.wired": "Wired",
  "sites.cloud.unblock": "Unblock",
  "sites.cloud.unblocked": "Unblocked",
  "sites.cloud.block": "Block",
  "sites.cloud.blockedDone": "Blocked",
  "sites.cloud.blockConfirm": "Block {name}? It cannot connect again until it is unblocked.",
  "sites.cloud.reconnect": "Reconnect",
  "sites.cloud.reconnectSent": "Reconnect sent",
  "sites.cloud.uplinks": "Uplinks",
  "sites.cloud.noUplinks": "No uplinks reported.",
  "sites.cloud.up": "Up",
  "sites.cloud.down": "Down",
  "sites.cloud.alerts": "Alerts",
  "sites.cloud.events": "Recent events from {vendor}",
  "sites.cloud.eventsFailed": "The controller did not answer: {reason}",
  "sites.cloud.noEvents": "No recent events.",
  "sites.config.field.ssidOn": "SSID on",
  "sites.config.field.wifiKey": "WiFi key",
  "sites.config.help.wifiKey": "Written only: the current key is never shown",
  "sites.config.field.networkName": "Network name",
  "sites.config.field.siteName": "Site name on the controller",
  "sites.config.help.siteName": "The dashboard's own name for the site stays as it is",
  "sites.config.secretSet": "Set — type a new one to change it",
  "sites.cloud.lanAddressHint": "Its own address on the network at the site: the forward goes to it, and the network it is on keeps its VLAN from here.",
  "sites.cloud.controllerPort": "The controller's own port",
  "sites.cloud.controllerPortHint": "8043 on a software controller, 443 on an OC200 or OC300",
  "sites.cloud.secretAgain": "Type the client secret again when the address, the site or the port changes: it is never sent to a new address by itself.",
  "sites.config.historySection.devices": "Devices",
  "sites.config.historySection.clients": "Clients",
  "sites.removeSite": "Remove site",
  "sites.removeConfirm": "Remove the site \"{name}\"? Its history, alerts, settings and VPN connection go with it. This cannot be undone.",
  "sites.config.help.radioOn": "Turning off a radio that carries a link cuts that link",
  "sites.vpn.title": "VPN connection",
  "sites.vpn.connected": "Connected",
  "sites.vpn.waiting": "Waiting for its VPN connection",
  "sites.vpn.notConnected": "Not connected",
  "sites.vpn.waitingPage": "Waiting for its VPN connection: the device’s details show here once it connects",
  "sites.vpn.tunnelAddress": "Tunnel address",
  "sites.vpn.lastSeen": "Last connected",
  "sites.vpn.never": "Never",
  "sites.vpn.loadHint": "Load this file on the router as an OpenVPN client, and let HTTPS (port 443) in from the VPN on the router (on a Teltonika: Network → Firewall → Traffic rules, from zone openvpn to the device, TCP 443, accept); the site comes online here once it connects",
  "sites.vpn.download": "Download .ovpn",
  "sites.vpn.downloadFailed": "Download failed",
  "sites.vpn.renew": "Renew certificate",
  "sites.vpn.renewed": "New VPN file created for the site",
  "sites.vpn.renewFailed": "No new VPN file could be created",
  "sites.signIn.change": "Change sign-in",
  "sites.signIn.title": "Change the sign-in of {name}",
  "sites.signIn.hint": "A field left empty keeps what is stored. Passwords and tokens are stored encrypted and never shown.",
  "sites.signIn.user": "User name",
  "sites.signIn.password": "Password",
  "sites.signIn.token": "API token",
  "sites.signIn.apiKey": "API key",
  "sites.signIn.save": "Save sign-in",
  "sites.signIn.saved": "Sign-in saved",
  "sites.signIn.savedText": "The device is asked again with it now",
  "sites.signIn.failed": "The sign-in could not be saved",
  "sites.direct.toggle": "Disable the VPN connection and use a direct address or IP",
  "sites.add.vpnLine": "Reached through its VPN connection, at the gateway’s tunnel address — found on its own",
  "sites.event.brand": "Events",
  "sites.event.badge": "Event",
  "sites.event.archived": "Archived",
  "sites.archivedHint": "Sites of closed events: kept here for the archive time in the rental settings, then removed.",
  "sites.event.rentalEvent": "Rental event",
  "sites.event.period": "Rental period",
  "sites.event.material": "Material out and back",
  "sites.event.devices": "Devices",
  "sites.event.device": "Device",
  "sites.event.cameIn": "Came in",
  "sites.event.state": "Status",
  "sites.event.uptime": "Uptime",
  "sites.event.clients": "Clients",
  "sites.event.traffic": "Traffic",
  "sites.event.lastSeen": "Last seen",
  "sites.event.noDevices": "No device of what is loaded is out now",
  "sites.event.hidden": { one: "{count} device hidden: you may not see its site", other: "{count} devices hidden: you may not see their sites" },
  "sites.event.alerts": "Alerts",
  "sites.event.noAlerts": "No alerts",
  "sites.event.resolved": "resolved",
  "sites.event.clientList": "Network clients",
  "sites.event.noClients": "No clients",
  "sites.event.loads": "What went out",
  "sites.event.noLoads": "Nothing has gone out yet",
  "sites.event.wentOut": "Out {when} · {who}",
  "sites.event.cameBack": "Back {when} · {who}: {status}",
  "sites.event.stillOut": "still out",
  "sites.event.cameBackOf": "{back} of {out} came back",
  "sites.event.graphs": "Graphs",
  "sites.event.range": "Range",
  "sites.event.range24h": "24 h",
  "sites.event.range3d": "3 days",
  "sites.event.range1w": "1 week",
  "sites.event.rangeThisMonth": "This month",
  "sites.event.rangeLastMonth": "Last month",
  "sites.event.rangeCustom": "Custom",
  "sites.event.from": "From",
  "sites.event.to": "To",
  "sites.event.rangeInvalid": "The end is before the start",
  "sites.event.totalInRange": "In this range: ↓ {rx} · ↑ {tx}",
  "sites.event.graphTraffic": "Total traffic",
  "sites.event.graphDevices": "Devices online and offline",
  "sites.event.noSamples": "Nothing recorded in this range: the graphs fill while the material is out",
  "sites.event.asTable": "Show as a table",
  "sites.event.time": "Time",
  "sites.cloud.username": "User name",
  "sites.cloud.password": "Password",
  "sites.cloud.registerTitleSz": "Add Ruckus sites",
  "sites.cloud.registerSubtitleSz": "A Ruckus SmartZone controller's zones, reached through a site's VPN or at an address",
  "sites.cloud.credentialsSz": "SmartZone's credentials",
  "sites.cloud.credentialsWhereSz": "A SmartZone administrator with a read-write role ({menu})",
  "sites.cloud.secretAgainSz": "Type the password again when the address, the site or the port changes: it is never sent to a new address by itself.",
  "sites.cloud.controllerPortHintSz": "8443 on SmartZone",
  "sites.cloud.siteFirmware": "Update AP firmware",
  "sites.cloud.siteFirmwareCurrent": "Current version",
  "sites.cloud.siteFirmwareNew": "New version",
  "sites.cloud.siteFirmwareNone": "No newer version on the controller",
  "sites.cloud.siteFirmwareUpdate": "Update",
  "sites.cloud.siteFirmwareConfirm": "Every access point of this site restarts to move to {version}. Go on?",
  "sites.cloud.siteFirmwareSent": "Firmware update started",
  "sites.config.wifiOnly": "This controller's sites have WiFi settings only: VLANs are set per WiFi network.",
  "sites.event.comment": "Comment",
  "sites.event.commentOf": "Comment for {name}",
  "sites.event.commentPlaceholder": "Add a comment",
  "sites.event.commentSaved": "Comment saved",
  "sites.event.commentFailed": "The comment was not saved",
  "sites.event.commentBy": "{name}, {when}",
  "sites.add.choose": "What are you adding?",
  "sites.speedTest": "Speed test ↓ {down} ↑ {up}",
  "sites.speedTestAt": "The gateway's last speed test, {when}: what the line can carry",
  "sites.dataUsed": "Data used ({period}): ↓ {rx} ↑ {tx}",
}

export default sites
